module.exports = __webpack_public_path__ + "static/img/9.57fae0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/9.png
// module id = ewwd
// module chunks = 1